import React, { useState } from 'react';

function SurveyStepSix({ formData, onNext }) {
    const [trainingCompletion, setTrainingCompletion] = useState(formData.trainingCompletion || '');
    const [trainingComments, setTrainingComments] = useState(formData.trainingComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!trainingCompletion) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ trainingCompletion, trainingComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 1: Compliance & Training</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How fully have you completed mandatory training modules in the last 12 months? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`training-completion-${option}`}
                            name="trainingCompletion"
                            value={option}
                            checked={trainingCompletion === option}
                            onChange={() => setTrainingCompletion(option)}
                        />
                        <label htmlFor={`training-completion-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={trainingComments}
                    onChange={(e) => setTrainingComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!trainingCompletion}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepSix;
